import { configureStore } from '@reduxjs/toolkit';
import taskReducer from './taskSlice';
import agentReducer from './agentSlice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    tasks: taskReducer,
    agents: agentReducer,
    auth: authReducer,
  },
});
